import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "cc_access_token";

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
});

// Attach bearer token from localStorage on every request
api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function setAuthToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function apiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function inr(n) {
  const val = Number(n || 0);
  const sign = val < 0 ? "-" : "";
  const abs = Math.abs(val).toLocaleString("en-IN", { maximumFractionDigits: 2 });
  return `${sign}₹${abs}`;
}

export function fmtDate(d) {
  if (!d) return "";
  try {
    const dt = typeof d === "string" ? new Date(d) : d;
    return dt.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return String(d);
  }
}

export function fmtDateTime(d) {
  if (!d) return "";
  try {
    const dt = typeof d === "string" ? new Date(d) : d;
    return dt.toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return String(d);
  }
}

/**
 * WhatsApp click-to-chat URL with a pre-filled message.
 * Uses api.whatsapp.com directly: the wa.me redirect re-encodes the text and
 * turns emoji like 🏏 into "�".
 */
export function whatsappShareUrl(text, phone) {
  // With a phone number the chat opens straight to that person; 10-digit numbers are taken as Indian
  let digits = (phone || "").replace(/\D/g, "");
  if (digits.length === 10) digits = `91${digits}`;
  const to = digits.length >= 11 ? `phone=${digits}&` : "";
  return `https://api.whatsapp.com/send?${to}text=${encodeURIComponent(text)}`;
}

/** Base URL for links shared outside the app (set REACT_APP_PUBLIC_URL to the deployed site). */
export function publicAppUrl() {
  return (process.env.REACT_APP_PUBLIC_URL || window.location.origin).replace(/\/$/, "");
}

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

let _razorpayLoading = null;
export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve();
  if (_razorpayLoading) return _razorpayLoading;
  _razorpayLoading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = resolve;
    s.onerror = () => reject(new Error("Failed to load Razorpay"));
    document.head.appendChild(s);
  });
  return _razorpayLoading;
}
